import React, {Component} from "react";
import ErrorSpan from "../ErrorSpan";
import classNames from "classnames";

export default class Input extends Component {
    constructor() {
        super(...arguments);
    }

    render() {
        const {value, attr, label, isDisabled, required, error, type, placeholder} = this.props;

        return (
            <div className="form-group">
                <label htmlFor={attr}>
                    {label}
                    {required && <span className="text-danger">*</span>}
                </label>
                <input
                       type={type ? type : "text"}
                       className={classNames('form-control', {'is-invalid': Boolean(error)})}
                       value={value}
                       placeholder={placeholder}
                       readOnly={isDisabled}
                       onBlur={(e) => this.props.onBlur ? this.props.onBlur(attr, e.target.value) : null}
                       onChange={(e) => this.props.onChange(attr, e.target.value)}
                />
                {error && <ErrorSpan error={error}/>}
            </div>
        )
    }
}
